import { inject } from 'mobx-react'
import { observer } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import { CurrentCompanyStore } from '../../../../stores/CurrentCompanyStore'
import { InsightsPage } from '../../../../components/MfeParcels/InsightsPage'

interface InjectedProps {
  currentCompanyStore: CurrentCompanyStore
}

const _Insights: React.FC<InjectedProps> = (props) => {
  const companyStore = props.currentCompanyStore

  const unMount = () => {
    companyStore.setDisplayInsightsReportNavBar(false)
  }

  useEffect(() => {
    return unMount
  }, [])

  return (
    <>
      <InsightsPage />
    </>
  )
}

const Insights = inject('currentCompanyStore')(observer(_Insights))

export default Insights
